import { useCallback, useEffect, useState } from 'react';
import '../common/Recruit.scss'
import '../common/RecruitList.scss'
import MainURL from '../../../MainURL';
import ImageURL from '../../../ImageURL';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useDropzone } from 'react-dropzone'
import imageCompression from "browser-image-compression";
import { format } from "date-fns";
import { useAtom } from 'jotai';
import { userDataAtom } from '../../../AtomStore';
import { DropdownBox } from '../../../components/DropdownBox';
import { applydocSubSort, applyhowSubSort, careerSubSort, dawnPraySubMenu, hourSortOption, insuranceSubSort, minuteSortOption, 
        partDetailSubSort, 
        partSubSort, paySubSort, recruitNumSubSort, religiousbodySubSort, schoolSubSort, 
        severanceSubSort, 
        sortSortOption, sortSubSort, SubTitleControl, weekdaySubSort, 
        welfareSubSort, 
        workdaySubMenu, workDayWeekSortOption } from './RecruitOverseasPostData';
import {
  EMPTY_OVERSEAS_LOCATION,
  parseOverseasLocation,
  toOverseasLocationParams,
  type OverseasLocationValue,
} from './overseasData';
import OverseasLocationFields from './OverseasLocationFields';
import { DateBoxSingle } from '../../../components/DateBoxSingle';
import { CustomEditor } from '../../../components/CustomEditor';
import Loading from '../../../components/Loading';
import { CiCircleMinus } from 'react-icons/ci';
import { parseRecruitRowForForm } from '../common/recruitAdminEditLoad';
import ApplyMethodPicker from '../common/ApplyMethodPicker';

const PHONE_PREFIX_OPTIONS = [
  '010', '011', '016', '017', '018', '019',
  '02',
  '031', '032', '033',
  '041', '042', '043', '044',
  '051', '052', '053', '054', '055',
  '061', '062', '063', '064',
  '070', '080',
] as const;

const phonePrefixOptions = PHONE_PREFIX_OPTIONS.map((prefix) => ({ value: prefix, label: prefix }));
const mobilePhonePrefixes: string[] = PHONE_PREFIX_OPTIONS.filter((prefix) => prefix.startsWith('01'));

type RecruitOverseasPostProps = {
  adminEditId?: string | number;
  embeddedInModal?: boolean;
  onAdminSaved?: () => void;
  onAdminCancel?: () => void;
};

/** 해외사역지 공고 등록/관리자 수정 폼 — recruitMinisterOverseas 테이블 (/recruitoverseas API) */
export default function RecruitOverseasPost({
  adminEditId,
  embeddedInModal = false,
  onAdminSaved,
  onAdminCancel,
}: RecruitOverseasPostProps = {}) {

  let navigate = useNavigate();
  
  const [userData, setUserData] = useAtom(userDataAtom);

  const [title, setTitle] = useState('');
  const [writer, setWriter] = useState('');
  const originDate = new Date();
  const todayDate = format(originDate, 'yyyy-MM-dd');
  const [date, setDate] = useState(todayDate);
  const [source, setSource] = useState('사역자모아');
  const [link, setLink] = useState('');
  const [existingChurchLogo, setExistingChurchLogo] = useState('');
  const [formLoading, setFormLoading] = useState(Boolean(adminEditId));

  const [church, setChurch] = useState('');
  const [religiousbody, setReligiousbody] = useState('');
  const [overseasLocation, setOverseasLocation] = useState<OverseasLocationValue>(EMPTY_OVERSEAS_LOCATION);
  const [mainpastor, setMainpastor] = useState('');
  const [homepage, setHomepage] = useState('');
  const [churchLogo, setChurchLogo] = useState<File | null>(null);
  
  const [sort, setSort] = useState('');
  const [part, setPart] = useState([{sort:"전임", content:""}]);
  const [partDetail, setPartDetail] = useState([{sort:"전임", content:""}]);
  const [school, setSchool] = useState([{sort:"전임", content:""}]);
  const [career, setCareer] = useState([{sort:"전임", content:""}]);
  const [recruitNum, setRecruitNum] = useState('');

  const [workday, setWorkday] = useState([{sort:"전임", content:""}]);
  const [workTimeSunDay, setWorkTimeSunDay] = useState([{sort:"전임", startHour:"09", startMinute:"00", endHour:"16", endMinute:"00"}]);
  const [workTimeWeek, setWorkTimeWeek] = useState([{sort:"전임", startHour:"09", startMinute:"00", endHour:"17", endMinute:"00", day:"평일"}]);
  const [dawnPray, setDawnPray] = useState([{sort:"전임", content:""}]);

  const [pay, setPay] = useState([{sort:"전임", paySort:"월", selectCost:"", inputCost:""}]);
  const [insurance, setInsurance] = useState([{sort:"전임", content:""}]);
  const [severance, setSeverance] = useState([{sort:"전임", content:""}]);
  const [welfare, setWelfare] = useState([{sort:"전임", content:""}]);

  const [applytime, setApplytime] = useState({startDay:"", endDay:"", daySort:""});
  const [applydoc, setApplydoc] = useState([{sort:"전임", content:""}]);
  const [applyhow, setApplyhow] = useState('');
  const [inquiry, setInquiry] = useState({inquiryName:"", email:"", phone:""});
  const [notifiApprove, setNotifiApprove] = useState(false);
  const [personalInfo, setPersonalInfo] = useState<boolean | null>(null);
  const [etcNotice, setEtcNotice] = useState('');
  
  const [workdayMenu, setWorkdayMenu] = useState(['','']);
  const [dawnPrayMenu, setDawnPrayMenu] = useState(['','']);
  const [payInputType, setPayInputType] = useState('select');

  const [customInput, setCustomInput] = useState('');

  /** 페이지 하단까지 스크롤되면 저장 버튼을 우측 → 중앙으로 옮김 */
  const [isAtBottom, setIsAtBottom] = useState(false);
  const handleRecruitScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const el = e.currentTarget;
    const reached = el.scrollHeight - el.scrollTop - el.clientHeight < 80;
    setIsAtBottom(reached);
  };




  // 첨부 이미지 삭제 
  const deleteInputImage = async () => {
    setChurchLogo(null);
  };

  // 이미지 첨부 함수 ----------------------------------------------
  const [imageLoading, setImageLoading] = useState<boolean>(false);
  const onDrop = useCallback(async (acceptedFiles: File[]) => {
    if (acceptedFiles.length === 0) return;
    const file = acceptedFiles[0];
    try {
      setImageLoading(true);
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1000
      };
      const resizingBlob = await imageCompression(file, options);
      const regexCopy = /[^a-zA-Z0-9!@#$%^&*()\-_=+\[\]{}|;:'",.<>]/g;
      const userIdCopy = userData?.userAccount.slice(0,5);
      const regex = resizingBlob.name.replace(regexCopy, '');
      const regexSlice = regex.slice(-15);
      const newFile = new File([resizingBlob], `${date}${userIdCopy}_${regexSlice}`, {
        type: file.type,
      });
      setChurchLogo(newFile);
      setImageLoading(false);
    } catch (error) {
      setImageLoading(false);
      console.error('이미지 리사이징 중 오류 발생:', error);
    }
  }, [setChurchLogo]);
  const { getRootProps, getInputProps } = useDropzone({ onDrop }); 


  // 글쓰기 등록 함수 ----------------------------------------------
  const registerPost = async () => {
    if (imageLoading) return;
    const formData = new FormData();
    if (churchLogo) {
      formData.append('img', churchLogo);
    }

    const getParams = {
      userAccount: userData?.userAccount,
      title,
      source: '사역자모아',
      writer,
      date: todayDate,
      church,
      religiousbody,
      ...toOverseasLocationParams(overseasLocation),
      mainpastor,
      homepage,
      school: JSON.stringify(school),
      career: JSON.stringify(career),
      sort,
      part: JSON.stringify(part),
      partDetail: JSON.stringify(partDetail),
      recruitNum,
      workday: JSON.stringify(workday),
      workTimeSunDay: JSON.stringify(workTimeSunDay),
      workTimeWeek: JSON.stringify(workTimeWeek),
      dawnPray: JSON.stringify(dawnPray),
      pay: JSON.stringify(pay),
      welfare: JSON.stringify(welfare),
      insurance: JSON.stringify(insurance),
      severance: JSON.stringify(severance),
      applydoc: JSON.stringify(applydoc),
      applyhow,
      applytime: JSON.stringify(applytime),
      etcNotice,
      inquiry: JSON.stringify(inquiry),
      notifiApprove: notifiApprove ? 1 : 0,
      personalInfo: personalInfo ? 1 : 0,
      churchLogo: churchLogo ? churchLogo.name : '',
      customInput : customInput,
    };
    try {
      const res = await axios.post(`${MainURL}/recruitoverseas/postsrecruit`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        params: getParams,
      });
      if (res.data) {
        alert('등록이 완료되었습니다.');

        // if (inquiry.phone) {
        //   try {
        //     await axios.post(`${MainURL}/apikakaonotifi/recruit-register`, {
        //       phone: inquiry.phone,
        //       name: inquiry.inquiryName,
        //       churchName: church,
        //       postTitle: title,
        //       date: todayDate,
        //     });
        //   } catch (notifiError) {
        //     console.error('구인공고 등록 알림톡 발송 실패:', notifiError);
        //   }
        // }

        // 폼 리셋
        setTitle('');
        setWriter('');
        setChurch('');
        setReligiousbody('');
        setOverseasLocation(EMPTY_OVERSEAS_LOCATION);
        setMainpastor('');
        setHomepage('');
        setSort('');
        setPart([{sort:"전임", content:""}]);
        setPartDetail([{sort:"전임", content:""}]);
        setSchool([{sort:"전임", content:""}]);
        setCareer([{sort:"전임", content:""}]);
        setRecruitNum('');
        setWorkday([{sort:"전임", content:""}]);
        setWorkTimeSunDay([{sort:"전임", startHour:"09", startMinute:"00", endHour:"16", endMinute:"00"}]);
        setWorkTimeWeek([{sort:"전임", startHour:"09", startMinute:"00", endHour:"17", endMinute:"00", day:"평일"}]);
        setDawnPray([{sort:"전임", content:""}]);
        setPay([{sort:"전임", paySort:"월", selectCost:"", inputCost:""}]);
        setInsurance([{sort:"전임", content:""}]);
        setSeverance([{sort:"전임", content:""}]);
        setWelfare([{sort:"전임", content:""}]);
        setApplytime({startDay:"", endDay:"", daySort:""});
        setApplydoc([{sort:"전임", content:""}]);
        setApplyhow('');
        setInquiry({inquiryName:"", email:"", phone:""});
        setNotifiApprove(false);
        setPersonalInfo(null);
        setEtcNotice('');
        setCustomInput('');
        setChurchLogo(null);
        navigate(-1);
      }
    } catch (error) {
      setImageLoading(false);
      alert('등록에 실패했습니다. 다시 시도해 주세요.');
      console.log('실패함', error);
    }
  };

  useEffect(() => {
    if (!adminEditId) return;

    let cancelled = false;

    const loadAdminEdit = async () => {
      setFormLoading(true);
      try {
        const res = await axios.post(`${MainURL}/recruitoverseas/getrecruitdatapart`, { id: adminEditId });
        const rows = Array.isArray(res.data) ? res.data : res.data ? [res.data] : [];
        if (!rows[0] || cancelled) return;

        const parsed = parseRecruitRowForForm(rows[0] as Record<string, unknown>);
        setSource(parsed.source || '사역자모아');
        setLink(parsed.link);
        setTitle(parsed.title);
        setWriter(parsed.writer);
        setDate(parsed.date || todayDate);
        setChurch(parsed.church);
        setReligiousbody(parsed.religiousbody);
        setOverseasLocation(parseOverseasLocation(rows[0] as Record<string, unknown>));
        setMainpastor(parsed.mainpastor);
        setHomepage(parsed.homepage);
        setSort(parsed.sort);
        setPart(parsed.part);
        setPartDetail(parsed.partDetail);
        setSchool(parsed.school);
        setCareer(parsed.career);
        setRecruitNum(parsed.recruitNum);
        setWorkday(parsed.workday);
        setWorkTimeSunDay(parsed.workTimeSunDay);
        setWorkTimeWeek(parsed.workTimeWeek);
        setDawnPray(parsed.dawnPray);
        setPay(parsed.pay);
        setInsurance(parsed.insurance);
        setSeverance(parsed.severance);
        setWelfare(parsed.welfare);
        setApplytime(parsed.applytime);
        setApplydoc(parsed.applydoc);
        setApplyhow(parsed.applyhow);
        setInquiry(parsed.inquiry);
        setNotifiApprove(parsed.notifiApprove);
        setPersonalInfo(parsed.personalInfo);
        setEtcNotice(parsed.etcNotice);
        setCustomInput(parsed.customInput);
        setExistingChurchLogo(parsed.existingChurchLogo);
      } catch (error) {
        console.error('구인 공고 불러오기 오류:', error);
        alert('데이터를 불러오는 중 오류가 발생했습니다.');
        onAdminCancel?.();
      } finally {
        if (!cancelled) setFormLoading(false);
      }
    };

    void loadAdminEdit();
    return () => {
      cancelled = true;
    };
  }, [adminEditId, onAdminCancel, todayDate]);

  const revisePostAdmin = async () => {
    if (imageLoading || !adminEditId) return;

    const getParams = {
      postID: adminEditId,
      source,
      title,
      writer,
      date,
      link,
      church,
      religiousbody,
      ...toOverseasLocationParams(overseasLocation),
      mainpastor,
      homepage,
      school: JSON.stringify(school),
      career: JSON.stringify(career),
      sort,
      part: JSON.stringify(part),
      partDetail: JSON.stringify(partDetail),
      recruitNum,
      workday: JSON.stringify(workday),
      workTimeSunDay: JSON.stringify(workTimeSunDay),
      workTimeWeek: JSON.stringify(workTimeWeek),
      dawnPray: JSON.stringify(dawnPray),
      pay: JSON.stringify(pay),
      welfare: JSON.stringify(welfare),
      insurance: JSON.stringify(insurance),
      severance: JSON.stringify(severance),
      applydoc: JSON.stringify(applydoc),
      applyhow,
      applytime: JSON.stringify(applytime),
      etcNotice,
      inquiry: JSON.stringify(inquiry),
      notifiApprove: notifiApprove ? 1 : 0,
      personalInfo: personalInfo ? 1 : 0,
      churchLogo: churchLogo ? churchLogo.name : existingChurchLogo,
      customInput,
    };

    try {
      setImageLoading(true);
      const res = await axios.post(`${MainURL}/recruitoverseas/admin/reviserecruit`, getParams);
      setImageLoading(false);
      if (res.data?.success) {
        alert('수정이 완료되었습니다.');
        onAdminSaved?.();
      } else {
        alert('수정에 실패했습니다.');
      }
    } catch (error: unknown) {
      setImageLoading(false);
      const axiosError = error as { response?: { status?: number; data?: { error?: string; message?: string } } };
      if (axiosError.response?.status === 400 && axiosError.response?.data?.error === 'duplicate') {
        alert(axiosError.response.data.message || '이미 동일한 제목과 날짜의 글이 존재합니다.');
      } else {
        alert('수정에 실패했습니다. 다시 시도해 주세요.');
      }
      console.error('수정 실패:', error);
    }
  };

  const handleSubmit = () => {
    if (!title.trim() || !church.trim()) {
      alert('공고명과 교회명을 입력해주세요.');
      return;
    }
    if (isMobilePhone && notifiApprove && !personalInfo) {
      alert('개인정보(연락처) 제공에 동의해주세요.');
      return;
    }
    if (adminEditId) {
      void revisePostAdmin();
      return;
    }
    void registerPost();
  };

  const submitLabel = adminEditId ? '수정하기' : '저장하기';

  const [phonePart1 = '', phonePart2 = '', phonePart3 = ''] = inquiry.phone.split('-');
  const isMobilePhone = mobilePhonePrefixes.includes(phonePart1 || PHONE_PREFIX_OPTIONS[0]);

  if (formLoading) {
    return embeddedInModal ? <Loading /> : (
      <div className="recruit" style={{ padding: 40 }}>
        <Loading />
      </div>
    );
  }

  return (
    <>
    <div
      className={`recruit${embeddedInModal ? ' admin-recruit-edit-embedded' : ''}`}
      style={embeddedInModal ? { height: 'auto', overflowY: 'visible', paddingBottom: 24 } : { height: '700px', overflowY: 'auto', paddingBottom: 88 }}
      onScroll={embeddedInModal ? undefined : handleRecruitScroll}
    >

      <div className="inner">

        <div className="subpage__main">
          
          <section style={{marginBottom:'50px'}}>
            <div className="main_title_row">
              <h3 className='main_title'>
                {embeddedInModal ? '해외 구인 공고 수정' : '어떤 해외 사역자를 채용하시나요?'}
              </h3>
              {!embeddedInModal ? (
                <div className='postBtnbox'>
                  <div className='postBtn'
                    style={{marginRight:'10px'}}
                    onClick={()=>{navigate(-1);}}
                  >
                    <p>목록</p>
                  </div>
                </div>
              ) : null}
            </div>
          </section>

          {/* 기본정보 -------------------------------------------------------------------------- */}
          <section>
            <h1 className='section_title'>기본정보</h1>
            <div className='inputCover'>
              <div className="inputBox">
                <h3 className='title'><p>제목</p></h3>
                <div className="inputRow">
                  <input value={title} className="inputdefault" type="text" 
                    onChange={(e) => {setTitle(e.target.value)}}/>
                </div>
              </div>
              <div className="inputBox">
                <h3 className='title'><p>글쓰는이</p></h3>
                <div className="inputRow">
                  <input value={writer} className="inputdefault" type="text" 
                    onChange={(e) => {setWriter(e.target.value)}}/>
                </div>
              </div>
              <div className="inputBox">
                <h3 className='title'><p>날짜</p></h3>
                <div className="inputRow">
                  <input value={date} className="inputdefault" type="text" 
                    onChange={(e) => { setDate(e.target.value); }}/>
                </div>
              </div>
            </div>
          </section>

          {/* 교회정보 -------------------------------------------------------------------------- */}
          <section>
            <h1 className='section_title'>교회정보</h1>
            <div className='inputCover'>
              <div className="inputBox">
                <h3 className='title'><p>교회명</p></h3>
                <div className="inputRow">
                  <input value={church} className="inputdefault" type="text" 
                    onChange={(e) => {setChurch(e.target.value)}}/>
                </div>
              </div>
              <div className="inputBox">
                <h3 className='title'><p>교단</p></h3>
                <div className="inputRow">
                  <div className='checkTextRow'>
                    {
                      religiousbodySubSort.map((item:any, index:any)=>{
                        return (
                          <div key={index} className='checkTextBox'
                            onClick={()=>{
                              if (religiousbody === item) {
                                setReligiousbody('');
                              } else {
                                setReligiousbody(item);
                              }
                            }}
                          >
                            <input className="checkbox" type="checkbox"
                              checked={religiousbody === item}
                              onChange={()=>{setReligiousbody(item);}}
                            />
                            <span className="checkmark" />
                            <div className='imgtextBox'>
                              <img src={`${MainURL}/siteimages/religiousbody/${item}.jpg`}/>
                              <p className={religiousbody === item ? 'selected' : ''}>{item}</p>
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>
                </div>
              </div>
              <OverseasLocationFields value={overseasLocation} onChange={setOverseasLocation} />
              <div className="inputBox">
                <h3 className='title'><p>담임목사</p></h3>
                <div className="inputRow">
                  <input value={mainpastor} className="inputdefault" type="text" 
                    onChange={(e) => {setMainpastor(e.target.value)}}/>
                </div>
              </div>
              <div className="inputBox">
                <h3 className='title'><p>홈페이지</p></h3>
                <div className="inputRow">
                  <input value={homepage} className="inputdefault" type="text" 
                    placeholder='홈페이지 주소를 입력해주세요'
                    onChange={(e) => {setHomepage(e.target.value)}}/>
                </div>
              </div>
              <div className="inputBox">
                <h3 className='title'><p>교회로고</p></h3>
                <div className="inputRow">
                {
                  <div className="imageInputBox">
                  {
                    churchLogo &&
                    <div className='imagebox'>
                      <div className='imagebox'>
                        <img 
                          src={URL.createObjectURL(churchLogo)}
                        />
                        <p>{churchLogo.name}</p>
                        <div onClick={()=>{deleteInputImage();}}>
                          <CiCircleMinus color='var(--err)' size={20}/>
                        </div>
                      </div>
                    </div>
                  }
                  {
                    !churchLogo && existingChurchLogo &&
                    <div className='imagebox'>
                      <div className='imagebox'>
                        <img 
                          src={`${ImageURL}/images/recruit/churchlogo/${existingChurchLogo}`}
                          alt=""
                        />
                        <p>{existingChurchLogo}</p>
                        <div onClick={()=>{setExistingChurchLogo('');}}>
                          <CiCircleMinus color='var(--err)' size={20}/>
                        </div>
                      </div>
                    </div>
                  }
                  {
                    imageLoading ?
                    <div style={{width:'100%', height:'100%', position:'absolute'}}>
                      <Loading/>
                    </div>
                    :
                    <div className='imageDropzoneCover'  
                      style={{display: (churchLogo || existingChurchLogo) ? 'none' : 'block'}}>
                      <div {...getRootProps()} className="imageDropzoneStyle">
                        <input {...getInputProps()} />
                        {
                          !churchLogo && !existingChurchLogo
                          &&
                          <div className='imageplus'>+ 사진첨부하기</div>
                        }
                      </div>
                    </div>
                  }
                  </div>
                }
                <p style={{fontSize:'16px', color:'var(--ink-4)', marginTop:'10px'}}>
                  - 첨부 파일 형식은, 'JPG, PNG, JEPG' 파일만 가능합니다.
                </p>
                </div>
              </div>
              
            </div>
          </section>

          {/* 채용정보 -------------------------------------------------------------------------- */}
          <section>
            <h1 className='section_title'>채용정보</h1>
            <div className='inputCover'>
              <div className="inputBox">
                <h3 className='title'><p>직무</p></h3>
                <div className="inputRow">
                  <div className='checkTextRow'>
                    {
                      sortSubSort.map((item:any, index:any)=>{
                        return (
                          <div key={index} className='checkTextBox'
                            onClick={()=>{
                              if (sort === item) {
                                setSort('');
                                // 직무가 해제되면 모든 관련 배열을 초기화
                                setPart([{sort:"전임", content:""}]);
                                setPartDetail([{sort:"전임", content:""}]);
                                setSchool([{sort:"전임", content:""}]);
                                setCareer([{sort:"전임", content:""}]);
                                setWorkday([{sort:"전임", content:""}]);
                                setWorkTimeSunDay([{sort:"전임", startHour:"09", startMinute:"00", endHour:"16", endMinute:"00"}]);
                                setWorkTimeWeek([{sort:"전임", startHour:"09", startMinute:"00", endHour:"17", endMinute:"00", day:"평일"}]);
                                setDawnPray([{sort:"전임", content:""}]);
                                setPay([{sort:"전임", paySort:"월", selectCost:"", inputCost:""}]);
                                setInsurance([{sort:"전임", content:""}]);
                                setSeverance([{sort:"전임", content:""}]);
                                setWelfare([{sort:"전임", content:""}]);
                                setApplydoc([{sort:"전임", content:""}]);
                              } else {
                                setSort(item);
                               // 선택된 직무에 따라 배열 생성
                                if (item === '전임' || item === '준전임' || item === '파트' || item === '전임or준전임' || item === '전임or파트' || item === '준전임or파트' || item === '담임') {
                                  setPart([{sort:item, content:""}]);
                                  setPartDetail([{sort:item, content:""}]);
                                  setSchool([{sort:item, content:""}]);
                                  setCareer([{sort:item, content:""}]);
                                  setWorkday([{sort:item, content:""}]);
                                  setWorkTimeSunDay([{sort:item, startHour:"09", startMinute:"00", endHour:"16", endMinute:"00"}]);
                                  setWorkTimeWeek([{sort:item, startHour:"09", startMinute:"00", endHour:"17", endMinute:"00", day:"평일"}]);
                                  setDawnPray([{sort:item, content:""}]);
                                  setPay([{sort:item, paySort:"월", selectCost:"", inputCost:""}]);
                                  setInsurance([{sort:item, content:""}]);
                                  setSeverance([{sort:item, content:""}]);
                                  setWelfare([{sort:item, content:""}]);
                                  setApplydoc([{sort:item, content:""}]);
                                } else if (item === '전임&준전임') {
                                  setPart([{sort:"전임", content:""}, {sort:"준전임", content:""}]);
                                  setPartDetail([{sort:"전임", content:""}, {sort:"준전임", content:""}]);
                                  setSchool([{sort:"전임", content:""}, {sort:"준전임", content:""}]);
                                  setCareer([{sort:"전임", content:""}, {sort:"준전임", content:""}]);
                                  setWorkday([{sort:"전임", content:""}, {sort:"준전임", content:""}]);
                                  setWorkTimeSunDay([{sort:"전임", startHour:"09", startMinute:"00", endHour:"16", endMinute:"00"}, {sort:"준전임", startHour:"09", startMinute:"00", endHour:"16", endMinute:"00"}]);
                                  setWorkTimeWeek([{sort:"전임", startHour:"09", startMinute:"00", endHour:"17", endMinute:"00", day:"평일"}, {sort:"준전임", startHour:"09", startMinute:"00", endHour:"17", endMinute:"00", day:"평일"}]);
                                  setDawnPray([{sort:"전임", content:""}, {sort:"준전임", content:""}]);
                                  setPay([{sort:"전임", paySort:"월", selectCost:"", inputCost:""}, {sort:"준전임", paySort:"월", selectCost:"", inputCost:""}]);
                                  setInsurance([{sort:"전임", content:""}, {sort:"준전임", content:""}]);
                                  setSeverance([{sort:"전임", content:""}, {sort:"준전임", content:""}]);
                                  setWelfare([{sort:"전임", content:""}, {sort:"준전임", content:""}]);
                                  setApplydoc([{sort:"전임", content:""}, {sort:"준전임", content:""}]);
                                } else if (item === '전임&파트') {
                                  setPart([{sort:"전임", content:""}, {sort:"파트", content:""}]);
                                  setPartDetail([{sort:"전임", content:""}, {sort:"파트", content:""}]);
                                  setSchool([{sort:"전임", content:""}, {sort:"파트", content:""}]);
                                  setCareer([{sort:"전임", content:""}, {sort:"파트", content:""}]);
                                  setWorkday([{sort:"전임", content:""}, {sort:"파트", content:""}]);
                                  setWorkTimeSunDay([{sort:"전임", startHour:"09", startMinute:"00", endHour:"16", endMinute:"00"}, {sort:"파트", startHour:"09", startMinute:"00", endHour:"16", endMinute:"00"}]);
                                  setWorkTimeWeek([{sort:"전임", startHour:"09", startMinute:"00", endHour:"17", endMinute:"00", day:"평일"}, {sort:"파트", startHour:"09", startMinute:"00", endHour:"17", endMinute:"00", day:"평일"}]);
                                  setDawnPray([{sort:"전임", content:""}, {sort:"파트", content:""}]);
                                  setPay([{sort:"전임", paySort:"월", selectCost:"", inputCost:""}, {sort:"파트", paySort:"월", selectCost:"", inputCost:""}]);
                                  setInsurance([{sort:"전임", content:""}, {sort:"파트", content:""}]);
                                  setSeverance([{sort:"전임", content:""}, {sort:"파트", content:""}]);
                                  setWelfare([{sort:"전임", content:""}, {sort:"파트", content:""}]);
                                  setApplydoc([{sort:"전임", content:""}, {sort:"파트", content:""}]);
                                } else if (item === '준전임&파트') {
                                  setPart([{sort:"준전임", content:""}, {sort:"파트", content:""}]);
                                  setPartDetail([{sort:"준전임", content:""}, {sort:"파트", content:""}]);
                                  setSchool([{sort:"준전임", content:""}, {sort:"파트", content:""}]);
                                  setCareer([{sort:"준전임", content:""}, {sort:"파트", content:""}]);
                                  setWorkday([{sort:"준전임", content:""}, {sort:"파트", content:""}]);
                                  setWorkTimeSunDay([{sort:"준전임", startHour:"09", startMinute:"00", endHour:"16", endMinute:"00"}, {sort:"파트", startHour:"09", startMinute:"00", endHour:"16", endMinute:"00"}]);
                                  setWorkTimeWeek([{sort:"준전임", startHour:"09", startMinute:"00", endHour:"17", endMinute:"00", day:"평일"}, {sort:"파트", startHour:"09", startMinute:"00", endHour:"17", endMinute:"00", day:"평일"}]);
                                  setDawnPray([{sort:"준전임", content:""}, {sort:"파트", content:""}]);
                                  setPay([{sort:"준전임", paySort:"월", selectCost:"", inputCost:""}, {sort:"파트", paySort:"월", selectCost:"", inputCost:""}]);
                                  setInsurance([{sort:"준전임", content:""}, {sort:"파트", content:""}]);
                                  setSeverance([{sort:"준전임", content:""}, {sort:"파트", content:""}]);
                                  setWelfare([{sort:"준전임", content:""}, {sort:"파트", content:""}]);
                                  setApplydoc([{sort:"준전임", content:""}, {sort:"파트", content:""}]);
                                }
                              }
                            }}
                          >
                            <input className="checkbox" type="checkbox"
                              checked={sort === item}
                              onChange={()=>{setSort(item);}}
                            />
                            <span className="checkmark" />
                            <div className='imgtextBox'>
                              <p className={sort === item ? 'selected' : ''}>{item}</p>
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>
                </div>
              </div>
              <div className="inputBox">
                <h3 className='title'><p>담당파트</p></h3>
                <div className="inputRow">
                {
                  part.map((item: any, index: number) => {
                    return (
                      <div key={index}>
                        <SubTitleControl
                          index={index}
                          data={part}
                          setData={setPart}
                          sortOptions={sortSortOption}
                          defaultValues={{ sort: "전임", content: "" }}
                        />
                        <input
                          value={item.content}
                          className="inputdefault"
                          type="text"
                          onChange={(e) => {
                            const copy = [...part];
                            copy[index].content = e.target.value;
                            setPart(copy);
                          }}
                        />
                        <div className='subTextBox'>
                          {
                            partSubSort.map((subItem: string, subIndex: number) => {
                              const isSelected = item.content.split(', ').includes(subItem);
                              return (
                                <p key={subIndex}
                                  className={`subText ${isSelected ? 'selected' : ''}`}
                                  onClick={() => {
                                    const updated = [...part];
                                    const currentList = item.content ? item.content.split(', ') : [];

                                    if (isSelected) {
                                      updated[index].content = currentList
                                        .filter((i:any) => i !== subItem)
                                        .join(', ');
                                    } else {
                                      updated[index].content = [...currentList, subItem].join(', ');
                                    }

                                    setPart(updated);
                                  }}
                                >
                                  {subItem}
                                </p>
                              );
                            })
                          }
                        </div>
                      </div>
                    );
                  })
                }
                </div>
              </div>
              <div className="inputBox">
                <h3 className='title'><p>파트상세</p></h3>
                <div className="inputRow">
                {
                  partDetail.map((item: any, index: number) => {
                    return (
                      <div key={index}>
                        <SubTitleControl
                          index={index}
                          data={partDetail}
                          setData={setPartDetail}
                          sortOptions={sortSortOption}
                          defaultValues={{ sort: "전임", content: "" }}
                        />
                        <input
                          value={item.content}
                          className="inputdefault"
                          type="text"
                          onChange={(e) => {
                            const copy = [...partDetail];
                            copy[index].content = e.target.value;
                            setPartDetail(copy);
                          }}
                        />
                        <div className='subTextBox'>
                          {
                            partDetailSubSort.map((subItem: string, subIndex: number) => {
                              const isSelected = item.content.split(', ').includes(subItem);
                              return (
                                <p key={subIndex}
                                  className={`subText ${isSelected ? 'selected' : ''}`}
                                  onClick={() => {
                                    const updated = [...partDetail];
                                    const currentList = item.content ? item.content.split(', ') : [];

                                    if (isSelected) {
                                      updated[index].content = currentList
                                        .filter((i:any) => i !== subItem)
                                        .join(', ');
                                    } else {
                                      updated[index].content = [...currentList, subItem].join(', ');
                                    }

                                    setPartDetail(updated);
                                  }}
                                >
                                  {subItem}
                                </p>
                              );
                            })
                          }
                        </div>
                      </div>
                    );
                  })
                }
                </div>
              </div>
              <div className="inputBox">
                <h3 className='title'><p>학력</p></h3>
                <div className="inputRow">
                {
                  school.map((item: any, index: number) => {
                    return (
                      <div key={index}>
                        <SubTitleControl
                          index={index}
                          data={school}
                          setData={setSchool}
                          sortOptions={sortSortOption}
                          defaultValues={{ sort: "전임", content: "" }}
                        />
                        <input
                          value={item.content}
                          className="inputdefault"
                          type="text"
                          onChange={(e) => {
                            const copy = [...school];
                            copy[index].content = e.target.value;
                            setSchool(copy);
                          }}
                        />
                        <div className='subTextBox'>
                          {
                            schoolSubSort.map((subItem: string, subIndex: number) => {
                              const isSelected = item.content.split(', ').includes(subItem);
                              return (
                                <p key={subIndex}
                                  className={`subText ${isSelected ? 'selected' : ''}`}
                                  onClick={() => {
                                    const updated = [...school];
                                    const currentList = item.content ? item.content.split(', ') : [];

                                    if (isSelected) {
                                      updated[index].content = currentList
                                        .filter((i:any) => i !== subItem)
                                        .join(', ');
                                    } else {
                                      updated[index].content = [...currentList, subItem].join(', ');
                                    }

                                    setSchool(updated);
                                  }}
                                >
                                  {subItem}
                                </p>
                              );
                            })
                          }
                        </div>
                      </div>
                    );
                  })
                }
                </div>
              </div>
              <div className="inputBox">
                <h3 className='title'><p>경력</p></h3>
                <div className="inputRow">
                {
                  career.map((item: any, index: number) => {
                    return (
                      <div key={index}>
                        <SubTitleControl
                          index={index}
                          data={career}
                          setData={setCareer}
                          sortOptions={sortSortOption}
                          defaultValues={{ sort: "전임", content: "" }}
                        />
                        <input
                          value={item.content}
                          className="inputdefault"
                          type="text"
                          onChange={(e) => {
                            const copy = [...career];
                            copy[index].content = e.target.value;
                            setCareer(copy);
                          }}
                        />
                        <div className='subTextBox'>
                          {
                            careerSubSort.map((subItem: string, subIndex: number) => {
                              const isSelected = item.content.split(', ').includes(subItem);
                              return (
                                <p key={subIndex}
                                  className={`subText ${isSelected ? 'selected' : ''}`}
                                  onClick={() => {
                                    const updated = [...career];
                                    const currentList = item.content ? item.content.split(', ') : [];

                                    if (isSelected) {
                                      updated[index].content = currentList
                                        .filter((i:any) => i !== subItem)
                                        .join(', ');
                                    } else {
                                      updated[index].content = [...currentList, subItem].join(', ');
                                    }

                                    setCareer(updated);
                                  }}
                                >
                                  {subItem}
                                </p>
                              );
                            })
                          }
                        </div>
                      </div>
                    );
                  })
                }
                </div>
              </div>
              <div className="inputBox">
                <h3 className='title'><p>채용인원</p></h3>
                <div className="inputRow">
                  <div className='checkTextRow'>
                    {
                      recruitNumSubSort.map((item:any, index:any)=>{
                        return (
                          <div key={index} className='checkTextBox'
                            onClick={()=>{
                              if (recruitNum === item) {
                                setRecruitNum('');
                              } else {
                                setRecruitNum(item);
                              }
                            }}
                          >
                            <input className="checkbox" type="checkbox"
                              checked={recruitNum === item}
                              onChange={()=>{setRecruitNum(item);}}
                            />
                            <span className="checkmark" />
                            <div className='imgtextBox'>
                              <p className={recruitNum === item ? 'selected' : ''}>{item}</p>
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* 사역정보 -------------------------------------------------------------------------- */}
          <section>
            <h1 className='section_title'>사역정보</h1>
            <div className='inputCover'>
              <div className="inputBox">
                <h3 className='title'><p>사역요일</p></h3>
                <div className="inputRow">
                {
                  workday.map((item: any, index: number) => {
                    return (
                      <div key={index}>
                        <SubTitleControl
                          index={index}
                          data={workday}
                          setData={setWorkday}
                          sortOptions={sortSortOption}
                          defaultValues={{ sort: "전임", content: "" }}
                        />
                        <input
                          value={item.content}
                          className="inputdefault"
                          type="text"
                          onChange={(e) => {
                            const copy = [...workday];
                            copy[index].content = e.target.value;
                            setWorkday(copy);
                          }}
                        />
                        <div className='checkTextRow' style={{ display: 'flex' }}>
                          {
                            weekdaySubSort.map((day: string, dayIndex: number) => {
                              const selectedDays = item.content ? item.content.split(', ') : [];
                              const isChecked = selectedDays.includes(day);

                              return (
                                <div
                                  key={dayIndex}
                                  className='checkTextBox'
                                  onClick={() => {
                                    const updated = [...workday];
                                    const list = item.content ? item.content.split(', ') : [];
                                    if (isChecked) {
                                      updated[index].content = list.filter((d:any) => d !== day).join(', ');
                                    } else {
                                      updated[index].content = [...list, day].join(', ');
                                    }
                                    setWorkday(updated);
                                  }}
                                >
                                  <input
                                    className="checkbox"
                                    type="checkbox"
                                    checked={isChecked}
                                    readOnly // 직접 상태를 관리하므로 readOnly로 설정
                                  />
                                  <span className="checkmark" />
                                  <div className='imgtextBox'>
                                    <p className={`${isChecked ? 'selected' : ''}`}>{day}</p>
                                  </div>
                                </div>
                              );
                            })
                          }
                        </div>
                        <div className='checkTextRow' style={{display:'flex'}}>
                        {
                          workdaySubMenu.map((subItem:any, subIndex:any)=>{
                            return (
                              <div key={subIndex} className='checkTextBox'
                                onClick={() => {
                                  const copy = [...workday];
                                  if (workdayMenu === subItem) {
                                    const copyMenu = [...workdayMenu];
                                    copyMenu[index] = '';
                                    setWorkdayMenu(copyMenu);
                                  } else {
                                    const copyMenu = [...workdayMenu];
                                    copyMenu[index] = subItem;
                                    setWorkdayMenu(copyMenu);
                                    if (subItem === '주6일(화~일)') copy[index].content = '화,수,목,금,토,일';
                                    if (subItem === '주4일(수금토일)') copy[index].content = '수,금,토,일';
                                    if (subItem === '주3일(수토일)') copy[index].content = '수,토,일';
                                    if (subItem === '주3일(금토일)') copy[index].content = '금,토,일';
                                    if (subItem === '주말(토일)') copy[index].content = '토,일';
                                  }
                                  setWorkday(copy);
                                }}
                              >
                                <input className="checkbox"
                                  type="checkbox"
                                  checked={workdayMenu[index] === subItem}
                                  readOnly
                                />
                                <span className="checkmark" />
                                <div className='imgtextBox'>
                                  <p className={`${workdayMenu[index] === subItem ? 'selected': ''}`}>{subItem}</p>
                                </div>
                              </div>
                            )
                          })
                        }
                      </div>
                      </div>
                    );
                  })
                }
                </div>
              </div>
              <div className="inputBox">
                <h3 className='title'><p>사역시간(주일)</p></h3>
                <div className="inputRow">
                  {
                    workTimeSunDay.map((item:any, index:any)=>{
                      return (
                        <div key={index}>
                          <SubTitleControl
                            index={index}
                            data={workTimeSunDay}
                            setData={setWorkTimeSunDay}
                            sortOptions={sortSortOption}
                            defaultValues={{ sort: "전임", startHour: "09", startMinute: "00", endHour: "16", endMinute: "00" }}
                          />
                          <div className="selectBoxRow">
                            <DropdownBox
                              widthmain='15%'
                              height='50px'
                              selectedValue={item.startHour}
                              options={hourSortOption}
                              handleChange={(e)=>{
                                const copy = [...workTimeSunDay];
                                copy[index].startHour = e.target.value; 
                                setWorkTimeSunDay(copy);
                              }}
                            />
                            <DropdownBox
                              widthmain='15%'
                              height='50px'
                              selectedValue={item.startMinute}
                              options={minuteSortOption}
                              handleChange={(e)=>{
                                const copy = [...workTimeSunDay];
                                copy[index].startMinute = e.target.value; 
                                setWorkTimeSunDay(copy);
                              }}
                            />
                            <p style={{margin:'0 10px'}}>~</p>
                            <DropdownBox
                              widthmain='15%'
                              height='50px'
                              selectedValue={item.endHour}
                              options={hourSortOption}
                              handleChange={(e)=>{
                                const copy = [...workTimeSunDay];
                                copy[index].endHour = e.target.value; 
                                setWorkTimeSunDay(copy);
                              }}
                            />
                            <DropdownBox
                              widthmain='15%'
                              height='50px'
                              selectedValue={item.endMinute}
                              options={minuteSortOption}
                              handleChange={(e)=>{
                                const copy = [...workTimeSunDay];
                                copy[index].endMinute = e.target.value; 
                                setWorkTimeSunDay(copy);
                              }}
                            />
                          </div>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
              <div className="inputBox">
                <h3 className='title'><p>사역시간(평일)</p></h3>
                <div className="inputRow">
                  { 
                    workTimeWeek.map((item:any, index:any)=>{
                      return (
                        <div key={index}>
                          <SubTitleControl
                            index={index}
                            data={workTimeWeek}
                            setData={setWorkTimeWeek}
                            sortOptions={sortSortOption}
                            defaultValues={{ sort: "전임", startHour: "09", startMinute: "00", endHour: "17", endMinute: "00", day: "평일" }}
                          />
                          <div className="selectBoxRow">
                            <DropdownBox
                              widthmain='15%'
                              height='50px'
                              selectedValue={item.startHour}
                              options={hourSortOption}
                              handleChange={(e)=>{
                                const copy = [...workTimeWeek];
                                copy[index].startHour = e.target.value; 
                                setWorkTimeWeek(copy);
                              }}
                            />
                            <DropdownBox
                              widthmain='15%'
                              height='50px'
                              selectedValue={item.startMinute}
                              options={minuteSortOption}
                              handleChange={(e)=>{
                                const copy = [...workTimeWeek];
                                copy[index].startMinute = e.target.value; 
                                setWorkTimeWeek(copy);
                              }}
                            />
                            <p style={{margin:'0 10px'}}>~</p>
                            <DropdownBox
                              widthmain='15%'
                              height='50px'
                              selectedValue={item.endHour}
                              options={hourSortOption}
                              handleChange={(e)=>{
                                const copy = [...workTimeWeek];
                                copy[index].endHour = e.target.value; 
                                setWorkTimeWeek(copy);
                              }}
                            />
                            <DropdownBox
                              widthmain='15%'
                              height='50px'
                              selectedValue={item.endMinute}
                              options={minuteSortOption}
                              handleChange={(e)=>{
                                const copy = [...workTimeWeek];
                                copy[index].endMinute = e.target.value; 
                                setWorkTimeWeek(copy);
                              }}
                            />
                            <DropdownBox
                              widthmain='15%'
                              height='50px'
                              selectedValue={item.day}
                              options={workDayWeekSortOption}
                              handleChange={(e)=>{
                                const copy = [...workTimeWeek];
                                copy[index].day = e.target.value; 
                                setWorkTimeWeek(copy);
                              }}
                            />
                          </div>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
              <div className="inputBox">
                <h3 className='title'><p>새벽기도참석</p></h3>
                <div className="inputRow">
                {
                  dawnPray.map((item: any, index: number) => {
                    return (
                      <div key={index}>
                        <SubTitleControl
                          index={index}
                          data={dawnPray}
                          setData={setDawnPray}
                          sortOptions={sortSortOption}
                          defaultValues={{ sort: "전임", content: "" }}
                        />
                        <input
                          value={item.content}
                          className="inputdefault"
                          type="text"
                          onChange={(e) => {
                            const copy = [...dawnPray];
                            copy[index].content = e.target.value;
                            setDawnPray(copy);
                          }}
                        />
                        <div className='checkTextRow' style={{ display: 'flex' }}>
                          {
                            weekdaySubSort.map((day: string, dayIndex: number) => {
                              const selectedDays = item.content ? item.content.split(', ') : [];
                              const isChecked = selectedDays.includes(day);

                              return (
                                <div
                                  key={dayIndex}
                                  className='checkTextBox'
                                  onClick={() => {
                                    const updated = [...dawnPray];
                                    const list = item.content ? item.content.split(', ') : [];
                                    if (isChecked) {
                                      updated[index].content = list.filter((d:any) => d !== day).join(', ');
                                    } else {
                                      updated[index].content = [...list, day].join(', ');
                                    }
                                    setDawnPray(updated);
                                  }}
                                >
                                  <input
                                    className="checkbox"
                                    type="checkbox"
                                    checked={isChecked}
                                    readOnly // 직접 상태를 관리하므로 readOnly로 설정
                                  />
                                  <span className="checkmark" />
                                  <div className='imgtextBox'>
                                    <p className={`${isChecked ? 'selected' : ''}`}>{day}</p>
                                  </div>
                                </div>
                              );
                            })
                          }
                        </div>
                        <div className='checkTextRow' style={{display:'flex'}}>
                        {
                          dawnPraySubMenu.map((subItem:any, subIndex:any)=>{
                            return (
                              <div key={subIndex} className='checkTextBox'
                                onClick={() => {
                                  const copy = [...dawnPray];
                                  if (dawnPrayMenu === subItem) {
                                    const copyMenu = [...dawnPrayMenu];
                                    copyMenu[index] = '';
                                    setDawnPrayMenu(copyMenu);
                                  } else {
                                    const copyMenu = [...dawnPrayMenu];
                                    copyMenu[index] = subItem;
                                    setDawnPrayMenu(copyMenu);
                                    copy[index].content = subItem;
                                  }
                                  setDawnPray(copy);
                                }}
                              >
                                <input className="checkbox"
                                  type="checkbox"
                                  checked={dawnPrayMenu[index] === subItem}
                                  readOnly
                                />
                                <span className="checkmark" />
                                <div className='imgtextBox'>
                                  <p className={`${dawnPrayMenu[index] === subItem ? 'selected': ''}`}>{subItem}</p>
                                </div>
                              </div>
                            )
                          })
                        }
                        </div>
                      </div>
                    );
                  })
                }
                </div>
              </div>
            </div>
          </section>

          {/* 복지정보 -------------------------------------------------------------------------- */}
          <section>
            <h1 className='section_title'>복지정보</h1>
            <div className='inputCover'>
              <div className="inputBox">
                <h3 className='title'><p>사례</p></h3>
                <div className="inputRow">
                {
                  pay.map((item: any, index: number) => {
                    return (
                      <div key={index}>
                        <SubTitleControl
                          index={index}
                          data={pay}
                          setData={setPay}
                          sortOptions={sortSortOption}
                          defaultValues={{ sort: "전임", paySort: "select", selectCost: "", inputCost: "" }}
                        />
                        <div className='checkTextRow' style={{display:'flex'}}>
                          <div className='checkTextBox'>
                            <input className="checkbox"
                              type="checkbox"
                              checked={payInputType === 'select'}
                              readOnly
                            />
                            <span className="checkmark" 
                             onClick={() => {
                              setPayInputType('select');
                              const copy = [...pay];
                              copy[index].inputCost = '';
                              setPay(copy);
                            }}
                            />
                            <DropdownBox
                              widthmain='20%'
                              height='50px'
                              selectedValue={item.paySort}
                              options={[
                                {value:'월', label:'월'},
                                {value:'연', label:'연'},
                              ]}
                              handleChange={(e)=>{
                                const copy = [...pay];
                                copy[index].paySort = e.target.value; 
                                setPay(copy);
                              }}
                            />
                            <input
                              value={item.selectCost}
                              className="inputdefault"
                              style={{width:'20%'}}
                              type="text"
                              onClick={()=>{
                                setPayInputType('select');
                              }}
                              onChange={(e) => {
                                const copy = [...pay];
                                copy[index].selectCost = e.target.value; 
                                setPay(copy);
                              }}
                            />
                            <p style={{margin:'0 10px'}}>만원</p>
                          </div>
                        </div>
                        <div className='checkTextRow' style={{display:'flex'}}>
                          <div className='checkTextBox'>
                            <input className="checkbox"
                              type="checkbox"
                              checked={payInputType === 'input'}
                              readOnly
                            />
                            <span className="checkmark" 
                              onClick={() => {
                                setPayInputType('input');
                                const copy = [...pay];
                                copy[index].selectCost = '';
                                setPay(copy);
                              }}
                            />
                            <p style={{margin:'0 10px'}}>직접입력 :</p>
                            <input
                              value={item.inputCost}
                              className="inputdefault"
                              style={{width:'35%'}}
                              type="text"
                              onChange={(e) => {
                                const copy = [...pay];
                                copy[index].inputCost = e.target.value;
                                setPay(copy);
                              }}
                            />
                          </div>
                        </div>
                        <div className='subTextBox'>
                          {
                            paySubSort.map((subItem: string, subIndex: number) => {
                              const isSelected = item.inputCost.split(', ').includes(subItem);
                              return (
                                <p key={subIndex}
                                  className={`subText ${isSelected ? 'selected' : ''}`}
                                  onClick={() => {
                                    setPayInputType('input');
                                    const updated = [...pay];
                                    const currentList = item.inputCost ? item.inputCost.split(', ') : [];
                                    updated[index].selectCost = '';
                                    if (isSelected) {
                                      updated[index].inputCost = currentList
                                        .filter((i:any) => i !== subItem)
                                        .join(', ');
                                    } else {
                                      updated[index].inputCost = [...currentList, subItem].join(', ');
                                    }
                                    setPay(updated);
                                  }}
                                >
                                  {subItem}
                                </p>
                              );
                            })
                          }
                        </div>
                      </div>
                    );
                  })
                }
                </div>
              </div>
              <div className="inputBox">
                <h3 className='title'><p>보험</p></h3>
                <div className="inputRow">
                {
                  insurance.map((item: any, index: number) => {
                    return (
                      <div key={index}>
                        <SubTitleControl
                          index={index}
                          data={insurance}
                          setData={setInsurance}
                          sortOptions={sortSortOption}
                          defaultValues={{ sort: "전임", content: "" }}
                        />
                        <input
                          value={item.content}
                          className="inputdefault"
                          type="text"
                          onChange={(e) => {
                            const copy = [...insurance];
                            copy[index].content = e.target.value;
                            setInsurance(copy);
                          }}
                        />
                        <div className='subTextBox'>
                          {
                            insuranceSubSort.map((subItem: string, subIndex: number) => {
                              const isSelected = item.content.split(', ').includes(subItem);
                              return (
                                <p key={subIndex}
                                  className={`subText ${isSelected ? 'selected' : ''}`}
                                  onClick={() => {
                                    const updated = [...insurance];
                                    const currentList = item.content ? item.content.split(', ') : [];

                                    if (isSelected) {
                                      updated[index].content = currentList
                                        .filter((i:any) => i !== subItem)
                                        .join(', ');
                                    } else {
                                      updated[index].content = [...currentList, subItem].join(', ');
                                    }

                                    setInsurance(updated);
                                  }}
                                >
                                  {subItem}
                                </p>
                              );
                            })
                          }
                        </div>
                      </div>
                    );
                  })
                }
                </div>
              </div>
              <div className="inputBox">
                <h3 className='title'><p>퇴직금</p></h3>
                <div className="inputRow">
                {
                  severance.map((item: any, index: number) => {
                    return (
                      <div key={index}>
                        <SubTitleControl
                          index={index}
                          data={severance}
                          setData={setSeverance}
                          sortOptions={sortSortOption}
                          defaultValues={{ sort: "전임", content: "" }}
                        />
                        <input
                          value={item.content}
                          className="inputdefault"
                          type="text"
                          onChange={(e) => {
                            const copy = [...severance];
                            copy[index].content = e.target.value;
                            setSeverance(copy);
                          }}
                        />
                        <div className='subTextBox'>
                          {
                            severanceSubSort.map((subItem: string, subIndex: number) => {
                              const isSelected = item.content.split(', ').includes(subItem);
                              return (
                                <p key={subIndex}
                                  className={`subText ${isSelected ? 'selected' : ''}`}
                                  onClick={() => {
                                    const updated = [...severance];
                                    const currentList = item.content ? item.content.split(', ') : [];

                                    if (isSelected) {
                                      updated[index].content = currentList
                                        .filter((i:any) => i !== subItem)
                                        .join(', ');
                                    } else {
                                      updated[index].content = [...currentList, subItem].join(', ');
                                    }

                                    setSeverance(updated);
                                  }}
                                >
                                  {subItem}
                                </p>
                              );
                            })
                          }
                        </div>
                      </div>
                    );
                  })
                }
                </div>
              </div>
              <div className="inputBox">
                <h3 className='title'><p>복리후생</p></h3>
                <div className="inputRow">
                {
                  welfare.map((item: any, index: number) => {
                    return (
                      <div key={index}>
                        <SubTitleControl
                          index={index}
                          data={welfare}
                          setData={setWelfare}
                          sortOptions={sortSortOption}
                          defaultValues={{ sort: "전임", content: "" }}
                        />
                        <input
                          value={item.content}
                          className="inputdefault"
                          type="text"
                          onChange={(e) => {
                            const copy = [...welfare];
                            copy[index].content = e.target.value;
                            setWelfare(copy);
                          }}
                        />
                        <div className='subTextBox'>
                          {
                            welfareSubSort.map((subItem: string, subIndex: number) => {
                              const isSelected = item.content.split(', ').includes(subItem);
                              return (
                                <p key={subIndex}
                                  className={`subText ${isSelected ? 'selected' : ''}`}
                                  onClick={() => {
                                    const updated = [...welfare];
                                    const currentList = item.content ? item.content.split(', ') : [];

                                    if (isSelected) {
                                      updated[index].content = currentList
                                        .filter((i:any) => i !== subItem)
                                        .join(', ');
                                    } else {
                                      updated[index].content = [...currentList, subItem].join(', ');
                                    }

                                    setWelfare(updated);
                                  }}
                                >
                                  {subItem}
                                </p>
                              );
                            })
                          }
                        </div>
                      </div>
                    );
                  })
                }
                </div>
              </div>
            </div>
          </section>

          {/* 지원정보 -------------------------------------------------------------------------- */}
          <section>
            <h1 className='section_title'>지원정보</h1>
            <div className='inputCover'>
              <div className="inputBox">
                <h3 className='title'><p>지원기간</p></h3>
                <div className="inputRow" style={{display:'flex', alignItems:'center'}}>
                  <DateBoxSingle
                    date={applytime.startDay} 
                    setSelectDate={(e:any)=>{ 
                      const copy = {...applytime};
                      copy.startDay = e;
                      setApplytime(copy);
                    }} 
                  />
                  <p style={{margin:'0 10px'}}>부터</p>
                  {
                    applytime.daySort === "" 
                    &&
                    <>
                    <DateBoxSingle
                      date={applytime.endDay} 
                      setSelectDate={(e:any)=>{ 
                        const copy = {...applytime};
                        copy.endDay = e;
                        setApplytime(copy);
                      }} 
                    />
                    <p style={{margin:'0 10px'}}>까지</p>
                    </>
                  }
                  <div className='checkTextRow' style={{display:'flex', width:'20%', marginLeft:'20px'}}>
                    <div className='checkTextBox'>
                      <input className="checkbox"
                        type="checkbox"
                        checked={applytime.daySort === "채용시마감"}
                        readOnly
                      />
                      <span className="checkmark" 
                        onClick={() => {
                          const copy = {...applytime};
                          if (copy.daySort === '채용시마감') {
                            copy.daySort = ''  
                          } else {
                            copy.endDay = '';
                            copy.daySort = '채용시마감'
                          }
                          setApplytime(copy);
                        }}
                      />
                      <p style={{margin:'0 5px'}}>채용시마감</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="inputBox">
                <h3 className='title'><p>지원서류</p></h3>
                <div className="inputRow">
                {
                  applydoc.map((item: any, index: number) => {
                    return (
                      <div key={index}>
                        <SubTitleControl
                          index={index}
                          data={applydoc}
                          setData={setApplydoc}
                          sortOptions={sortSortOption}
                          defaultValues={{ sort: "전임", content: "" }}
                        />
                        <input
                          value={item.content}
                          className="inputdefault"
                          type="text"
                          onChange={(e) => {
                            const copy = [...applydoc];
                            copy[index].content = e.target.value;
                            setApplydoc(copy);
                          }}
                        />
                        <div className='checkTextRow' style={{ display: 'flex' }}>
                          {
                            applydocSubSort.map((day: string, dayIndex: number) => {
                              const selectedDays = item.content ? item.content.split(', ') : [];
                              const isChecked = selectedDays.includes(day);

                              return (
                                <div
                                  key={dayIndex}
                                  className='checkTextBox'
                                  onClick={() => {
                                    const updated = [...applydoc];
                                    const list = item.content ? item.content.split(', ') : [];
                                    if (isChecked) {
                                      updated[index].content = list.filter((d:any) => d !== day).join(', ');
                                    } else {
                                      updated[index].content = [...list, day].join(', ');
                                    }
                                    setApplydoc(updated);
                                  }}
                                >
                                  <input
                                    className="checkbox"
                                    type="checkbox"
                                    checked={isChecked}
                                    readOnly // 직접 상태를 관리하므로 readOnly로 설정
                                  />
                                  <span className="checkmark" />
                                  <div className='imgtextBox'>
                                    <p className={`${isChecked ? 'selected' : ''}`}>{day}</p>
                                  </div>
                                </div>
                              );
                            })
                          }
                        </div>
                      </div>
                    );
                  })
                }
                </div>
              </div>
              <div className="inputBox">
                <h3 className='title'><p>지원방법</p></h3>
                <div className="inputRow">
                  <ApplyMethodPicker
                    value={applyhow}
                    onChange={setApplyhow}
                    options={applyhowSubSort}
                    siteApply={true}
                    hasEmail={Boolean(String(inquiry.email || '').trim())}
                  />
                </div>
              </div>
              <div className="inputBox">
                <h3 className='title'><p>담당자</p></h3>
                <div className="inputRow">
                  <div className="subTitle second">
                    <p></p>
                    <div style={{width:'70px', marginRight:'10px'}}><p>이름</p></div>
                    <input value={inquiry.inquiryName} className="inputdefault" type="text" 
                      placeholder='' style={{width:'50%'}}
                      onChange={(e) => {setInquiry({...inquiry, inquiryName:e.target.value})}}/>
                  </div>
                  <div className="subTitle second">
                    <p></p>
                    <div style={{width:'70px', marginRight:'10px'}}><p>e-메일</p></div>
                    <input value={inquiry.email} className="inputdefault" type="text" 
                      placeholder='' style={{width:'50%'}}
                      onChange={(e) => {setInquiry({...inquiry, email:e.target.value})}}/>
                  </div>
                  <div className="subTitle second">
                    <p></p>
                    <div style={{width:'70px', marginRight:'10px'}}><p>연락처</p></div>
                    <div style={{width:'50%', display:'flex', alignItems:'center'}}>
                      <DropdownBox
                        widthmain='30%'
                        height='50px'
                        selectedValue={phonePart1 || PHONE_PREFIX_OPTIONS[0]}
                        options={phonePrefixOptions}
                        handleChange={(e) => {
                          setInquiry({...inquiry, phone: [e.target.value, phonePart2, phonePart3].join('-')});
                        }}
                      />
                      <span style={{margin:'0 6px'}}>-</span>
                      <input value={phonePart2} className="inputdefault" type="text" inputMode="numeric"
                        placeholder='' maxLength={4} style={{width:'30%'}}
                        onChange={(e) => {
                          const digits = e.target.value.replace(/\D/g, '').slice(0, 4);
                          setInquiry({...inquiry, phone: [phonePart1, digits, phonePart3].join('-')});
                        }}/>
                      <span style={{margin:'0 6px'}}>-</span>
                      <input value={phonePart3} className="inputdefault" type="text" inputMode="numeric"
                        placeholder='' maxLength={4} style={{width:'30%'}}
                        onChange={(e) => {
                          const digits = e.target.value.replace(/\D/g, '').slice(0, 4);
                          setInquiry({...inquiry, phone: [phonePart1, phonePart2, digits].join('-')});
                        }}/>
                    </div>
                  </div>
                  {/* <p style={{width:'100%', marginLeft:'100px', marginTop:'6px', fontSize:'15px', color:'var(--ink-3)'}}>핸드폰 번호를 기재하시면, 카톡으로 알림을 받을수 있습니다.</p> */}
                </div>
              </div>
              {/* {isMobilePhone && (
              <div className="inputBox">
                <h3 className='title'><p>카톡알림 서비스 (무료)</p></h3>
                <div className="inputRow">
                  <div className='checkTextRow'>
                    <div className='checkTextBox'
                      onClick={() => { setNotifiApprove(true); setPersonalInfo(true); }}
                    >
                      <input className="checkbox" type="checkbox"
                        checked={notifiApprove === true}
                        onChange={() => { setNotifiApprove(true); setPersonalInfo(true); }}
                      />
                      <span className="checkmark" />
                      <div className='imgtextBox'>
                        <p className={notifiApprove === true ? 'selected' : ''}>신청</p>
                      </div>
                    </div>
                    <div className='checkTextBox'
                      onClick={() => { setNotifiApprove(false); setPersonalInfo(false); }}
                    >
                      <input className="checkbox" type="checkbox"
                        checked={notifiApprove === false}
                        onChange={() => { setNotifiApprove(false); setPersonalInfo(false); }}
                      />
                      <span className="checkmark" />
                      <div className='imgtextBox'>
                        <p className={notifiApprove === false ? 'selected' : ''}>신청안함</p>
                      </div>
                    </div>
                  </div>
                  <p style={{width:'100%', marginTop:'6px', fontSize:'15px', color:'var(--ink-3)'}}>신청하시면 이력서가 들어올때마다 알림을 받을수 있습니다.</p>
                </div>
              </div>
              )}
              {isMobilePhone && notifiApprove === true && (
              <div className="inputBox">
                <h3 className='title'><p>개인정보제공(연락처)</p></h3>
                <div className="inputRow">
                  <div className='checkTextRow'>
                    <div className='checkTextBox'
                      onClick={() => setPersonalInfo(true)}
                    >
                      <input className="checkbox" type="checkbox"
                        checked={personalInfo === true}
                        onChange={() => setPersonalInfo(true)}
                      />
                      <span className="checkmark" />
                      <div className='imgtextBox'>
                        <p className={personalInfo === true ? 'selected' : ''}>동의</p>
                      </div>
                    </div>
                    <div className='checkTextBox'
                      onClick={() => { setPersonalInfo(false); alert('개인정보제공(연락처)을 하지 않으시면 카톡 알림 서비스를 받을 수 없습니다'); setNotifiApprove(false); }}
                    >
                      <input className="checkbox" type="checkbox"
                        checked={personalInfo === false}
                        onChange={() => { setPersonalInfo(false); alert('개인정보제공(연락처)을 하지 않으시면 카톡 알림 서비스를 받을 수 없습니다'); setNotifiApprove(false); }}
                      />
                      <span className="checkmark" />
                      <div className='imgtextBox'>
                        <p className={personalInfo === false ? 'selected' : ''}>비동의</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              )} */}
              <div className="inputBox">
                <h3 className='title'><p>기타사항</p></h3>
                <div className="inputRow">
                  <textarea
                    value={etcNotice}
                    className="inputdefault"
                    placeholder=''
                    onChange={(e) => {setEtcNotice(e.target.value)}}
                    style={{ height: '100px', resize: 'none', width: '100%', outline: 'none', padding: '10px' }}
                  />
                </div>
              </div>
            </div>
          </section>

          {/* 직접 입력하기 -------------------------------------------------------------------------- */}
          <section>
            <h1 className='section_title'>상세내용</h1>
            <div className='inputCover'>
              <div className="inputBox">
                <div className="inputRow" style={{width:'100%'}}>
                  <p style={{color:'var(--ink-3)', fontSize:'15px', marginBottom:'10px'}}>* 최대 2000자 이하로 작성해주세요.</p>
                  <CustomEditor
                    value={customInput}
                    onChange={setCustomInput}
                    widthProps="100%"
                    heightProps="1000px"
                  />
                </div>
              </div>
            </div>
          </section>

          {/* 본문 끝 인라인 저장 버튼 — 스크롤이 끝에 도달했을 때 노출됨 (플로팅은 숨김)
              관리자 수정 모달에서는 모달 스크롤 영역 우측 하단에 붙는 플로팅 버튼으로 표시 */}
          <div
            style={
              embeddedInModal
                ? {
                    position: 'sticky',
                    bottom: 16,
                    zIndex: 5,
                    display: 'flex',
                    justifyContent: 'flex-end',
                    margin: '20px 0 0',
                    pointerEvents: 'none',
                  }
                : {
                    display: 'flex',
                    justifyContent: 'center',
                    margin: '20px 0 40px',
                  }
            }
          >
            <div
              className="submitBtn"
              onClick={handleSubmit}
              style={{
                padding: embeddedInModal ? '14px 28px' : '14px 36px',
                minWidth: embeddedInModal ? 120 : 160,
                fontSize: 16,
                fontWeight: 'bold',
                color: '#fff',
                backgroundColor: 'var(--brand)',
                textAlign: 'center',
                borderRadius: embeddedInModal ? 999 : 5,
                boxShadow: embeddedInModal ? '0 6px 16px rgba(0,0,0,0.2)' : undefined,
                pointerEvents: 'auto',
                cursor: 'pointer',
              }}
            >
              {submitLabel}
            </div>
          </div>

        </div>
      </div>
    </div>

      {/* 플로팅 저장 버튼 — 우측 하단 고정, 페이지 끝에서는 숨김(본문 끝의 인라인 버튼이 그 자리를 대체) */}
      {!embeddedInModal && !isAtBottom && (
        <div
          className="floating-save-btn"
          onClick={handleSubmit}
          style={{
            position: 'fixed',
            bottom: 24,
            right: 24,
            padding: '14px 28px',
            minWidth: 120,
            fontSize: 16,
            fontWeight: 'bold',
            color: '#fff',
            backgroundColor: 'var(--brand)',
            textAlign: 'center',
            borderRadius: 999,
            boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
            cursor: 'pointer',
            zIndex: 1100,
          }}
        >
          {submitLabel}
        </div>
      )}
    </>
  )
}



